<script setup lang='ts'>
import WisionLogo from '../WisionLogo.vue';
import { useRouter } from 'vue-router';
import AvatarIcon from '../icons/AvatarIcon.vue';
import { useAppState } from '../../store/state';

const state = useAppState();
const router = useRouter();

</script>

<template>
  <div class="flex h-full flex-col items-center w-full px-10 text-onboard-shade2 justify-between">
    <div class="flex flex-col gap-8 justify-center h-full ">
      <div class="flex flex-col items-center">
        <WisionLogo :width="114" class="text-onboard-foreground"/>

        <span class="text-xl text-center mt-6 uppercase">
          {{ $t('nfc.welcome.title') }}
        </span>

        <div class="text-center mt-2 leading-none">
          <span class="text-sm uppercase">
            {{ $t('nfc.loginOrRegister') }}
          </span>
        </div>
      </div>

      <div class="flex w-full justify-center text-center">
        <div @click="router.push({ name: 'login' })">
          <AvatarIcon />
          {{ $t('login.signin') }}
        </div>
      </div>

      <div class="flex flex-col items-center">
        <span class="text-xl cursor-pointer uppercase" @click="router.push({ name: 'signup' })">
          {{ $t('nfc.register') }}
        </span>

        <div class="flex flex-col mt-8 text-onboard-shade1 items-center leading-none">
          <span>{{ state.unitName }}</span>
          <span>SERIE: {{ state.serial }}</span>
        </div>
      </div>
    </div>

    <span>
      <select v-model="$i18n.locale" class="bg-transparent" >
        <option 
          v-for="locale in $i18n.availableLocales" 
          :key="`locale-${locale}`" 
          :value="locale" 
          class="text-black"
        >
          {{ locale }}
        </option>
      </select>
    </span>
    <span class="text-onboard-shade1 pb-3 text-center">WISION BUILD {{ state.build }}</span>
  </div>
</template>

